export function range(value: number) {
  let x = []
  for (let i = 0; i < value; i++) {
    x.push(i)
  }
  return x
}
